import Icon, { IconName } from './Icon';

export const renderSwitcherIcon = (nodeProps: any) => {
  const { expanded } = nodeProps;
  return expanded ? <Icon showMask={false} name={IconName.arrowDown} /> :
    <Icon showMask={false} name={IconName.arrowDown} classIcon='origin-center -rotate-90' />
    ;
};
